import { useOrganizationSettings } from "./useOrganizationSettings";
import { useAuthenticated } from "../authenticated/useAuthenticated";
import { canScheduleOthers } from "../../../../helpers/src/permissions";

type FeatureFlagKey = keyof NonNullable<
  NonNullable<
    ReturnType<typeof useOrganizationSettings>["data"]
  >["feature_flags"]
>;

export const useOrgFeatureFlag = (key: FeatureFlagKey) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  
  const organizationId = authenticatedUser?.organization?.id;
  const { data: organizationSettings } = useOrganizationSettings({
    id: organizationId
  });
  
  if (key === "tessa") {
    const isAdmin = canScheduleOthers(authenticatedUser);
    return organizationSettings?.feature_flags?.tessa ? isAdmin : false;
  }

  return organizationSettings?.feature_flags?.[key] ?? null;
};
